import { Room } from '../models/rooms.model';

import { Injectable } from '@angular/core';

@Injectable()
export class RoomDetailService {

  rooms: Room[];

  constructor() { }

  getRoomDetail(idRoom: number): Room {
    this.rooms = JSON.parse(sessionStorage.getItem('roomsData'));
    return this.rooms[idRoom - 1];
  }
  
}